import { useState } from 'react';

import useConstant from './useConstant';
import { useDebounce } from './useDebounce';

export type OnChangeHandler = (text: string) => Promise<void> | void;
export type DebounceOptions = { millis?: number; initialValue?: string };

export const useDebouncedOnChange = (onChangeHandler: OnChangeHandler, opts?: DebounceOptions) => {
  const [text, setText] = useState(opts?.initialValue || '');

  const debouncedHandler = useDebounce(onChangeHandler, { millis: opts?.millis });

  const onChangeDebounced = useConstant(() => (value: string) => {
    setText(value);
    debouncedHandler(value);
  });

  return {
    text,
    setText,
    onChangeDebounced
  };
};
